<template>
  <div>
    <div id="detail_form_container">
        <div class="row">
          <div class="col-md-4 form-group">
            <label>La prestation vendue existe-t-elle déjà ? </label>
            <select v-model="activity" class="form-control">
              <option value="" disabled hidden>----- Veuillez sélectionner -----</option>
              <template v-for="mainActivity in mainActivities">
                <option v-if="mainActivity.price_type === 'standard'" :key="mainActivity.id"
                        :value="mainActivity">
                  {{ mainActivity.name }}
                </option>
                <optgroup v-else-if="mainActivity.price_type === 'package'" :label="mainActivity.name">
                  <option v-for="packagePrice in mainActivity.package_prices" :key="packagePrice.id"
                          :value="packagePrice">
                    {{ packagePrice.name }}
                  </option>
                </optgroup>
              </template>
            </select>
          </div>
      </div>
      <div class="form-group" id="saleDetailContainer">
        <div class="row">
          <div class="col-md-5">
            <label>Prestation vendue *:</label>
            <input type="text" class="form-control" name="details__input" v-model="newDetail.name" ref="input" v-on:keypress.enter.prevent="addDetail()" placeholder="Exemple"/>
          </div>
          <div class="col-md-1">
            <label >Quantité *:</label>
            <input type="number" class="form-control" min="0" name="details__input" v-model.number="newDetail.quantity" ref="input" v-on:keypress.enter.prevent="addDetail()" value=1 />
          </div>
          <div class="col-md-2">
            <label>Nombre de participants</label>
            <div class="input-group">
                  <span class="input-group-addon">
                    <input v-model="newDetail.isPackagePrice" type="checkbox" />
                  </span>
              <input v-model.number="newDetail.nbParticipants" type="number" name="nbParticipants" class="form-control"
                     :disabled="!newDetail.isPackagePrice"
              />
            </div>
          </div>
          <div class="col-md-2">
            <label>Prix unitaire (en €) *:</label>
            <input type="number" class="form-control" name="details__input" v-model="newDetail.price" ref="input" v-on:keypress.enter.prevent="addDetail()" placeholder="20" step="0.01" min="0" />
          </div>
        </div>
        <div class="row" style="padding-top:10px">
          <div class="col-md-3">
            <label>Date de début *:</label>
            <datepicker class="form-control datepicker" :value="newDetail.date_debut" v-model="newDetail.date_debut" name="details__input" @selected="selectedDatebegin" format="yyyy-MM-dd" full-month-name monday-first v-on:keypress.enter.prevent="addDetail()"></datepicker>
          </div>
          <div class="col-md-3">
            <label>Date de fin *:</label>
            <datepicker class="form-control datepicker" :value="newDetail.date_fin" v-model="newDetail.date_fin" name="details__input" :disabledDates="dateend.disabledDates" format="yyyy-MM-dd" full-month-name monday-first v-on:keypress.enter.prevent="addDetail()"></datepicker>
          </div>
          <div class="col-md-1 text-center">
            <a href="javascript:;" class="btn btn-success billingSuccess" id="detail__button" @click.prevent="addDetail()">Valider</a>
          </div>
          <input type="hidden" name="detail" :value="this.jsonDetails" id="detail">
        </div>
        <div id="errors_valid" v-show="errors != false" style="color:red">Veuillez remplir tous les champs du détail d'activité (non nuls) et la quantité ne peut pas être négative.</div>
      </div>
    </div>
    <div hidden class="alert alert-info" id="atLeastOneEnc">
      <span class="glyphicon glyphicon-info-sign"></span>
      Veuillez ajouter au moins un encadrant à chaque activité avant d'ajouter d'autres activités.
    </div>
    <div class="table-responsive">
      <table class="table table-striped" v-if="details.length > 0" id="activitiesTable">
          <template v-for="(detail, index) in details">
            <tbody v-bind:key="'detail_'+index">
            <tr v-show="getTotalEncQuantity(detail)!=0 && getTotalEncQuantity(detail)!=detail.quantity"><td colspan="8" class="alert alert-warning"><span class="glyphicon glyphicon-warning-sign"></span> La quantité de la prestation ne correspond pas à la quantité encadrée.</td></tr>
            <tr class="tableHead">
              <th COLSPAN=2>Dénomination de la prestation</th>
              <th>Quantité</th>
              <th></th>
              <th>Prix unitaire</th>
              <th>Date début</th>
              <th>Date fin</th>
              <th>Total</th>
              <th></th>
            </tr>
            <tr :id="'row_'+detail.billingActivityId" :key="detail.billingActivityId" class="activityRow" @click="DisplayEnc(detail,detail.quantity * detail.price)">
              <td COLSPAN=2>{{ detail.name }}</td>
              <td>{{ detail.quantity }}</td>
              <td></td>
              <td>{{ parseFloat(detail.price).toFixed(2) }} €</td>
              <td>
                <span v-if="detail.date_debut">
                  {{ detail.date_debut.split("-").reverse().join("/")}}
                </span>
              </td>
              <td>
                <span v-if="detail.date_fin">
                  {{ detail.date_fin.split("-").reverse().join("/")}}
                </span>
              </td>
              <td>{{ (detail.price * detail.quantity).toFixed(2) }} €</td>
              <td>
                <a href="javascript:;" class="btn-simple-icon btn-danger pull-right" @click.stop="deleteDetail(detail)"><i class="fa fa-trash"></i></a>
                <a href="javascript:;" class="btn-simple-icon pull-right" @click.stop="editDetail(detail)"><i class="fas fa-pencil-alt"></i></a>
              </td>
            </tr>
            </tbody>
            <template v-if="detail['enc']">
            <tbody :id="'encs_'+detail.billingActivityId" class="prestaEncsContainer" v-bind:key="'enc_'+index">
              <tr>
                <th></th>
                <th>Nom du pro</th>
                <th>Quantité</th>
                <th>Masses (%)</th>
                <th>Honoraire (€)</th>
                <th></th>
              </tr>
              <tr v-for="(pro,encIdx) in detail['enc']" v-bind:key="encIdx">
                <td>&emsp;&emsp;&emsp;&emsp;&emsp;</td>
                <td>{{ pro.name }} {{ pro.lastname }}</td>
                <td>{{ pro.quantity }}</td>
                <td v-if="pro.hasOwnProperty('percentage')">{{ pro.percentage.toFixed(2) }} %</td>
                <td v-else></td>
                <td>{{ pro.part }} € </td>
                <td v-if="pro.isRenfort">
                    <a href="javascript:;" class="btn-simple-icon btn-danger pull-right" @click="encDelete(pro.id,detail.billingActivityId,true)"><i class="fa fa-trash"></i></a>
                    <a href="javascript:;" class="btn-simple-icon pull-right" @click="encUpdate(pro.id,detail,true)"><i class="fas fa-pencil-alt"></i></a>
                </td>
                <td v-else>
                  <a href="javascript:;" class="btn-simple-icon btn-danger pull-right" @click="encDelete(pro.id,detail.billingActivityId,false)"><i class="fa fa-trash"></i></a>
                  <a href="javascript:;" class="btn-simple-icon pull-right" @click="encUpdate(pro.id,detail,false)"><i class="fas fa-pencil-alt"></i></a>
                </td>
              </tr>
            </tbody>
            </template>
          </template>
          <tbody>
            <tr>
              <td colspan="7">Total</td>
              <td colspan="2">{{ priceTotal.toFixed(2) }} €</td>
            </tr>
          </tbody>
      </table>
    </div>
      <div id="EncadrantContainer" hidden>
        <select-billing-encadrant-bureau
          :users-reinforcement="usersReinforcement" :renforts-reinforcement="renfortsReinforcement"
          :isencadrantsalarie="isencadrantsalarie" :hasmodulefacturebureau="true"
          :officeencadrant="officeencadrant " v-on:updatePrice="updatePrice()"
          :prestation="selectedPrestation" :prestationTotalPrice="prestationTotalPrice" :oldDetails="olddetails" @change="encadrantChange" :officecustomization="officecustomization" :hasbilling="hasbilling" :bookingmultipleenc="bookingmultipleenc">
        </select-billing-encadrant-bureau>
      </div>

      <input type="hidden" :value="priceTotal" name="price" />
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
export default {
  name: 'billingDetailComponent',
  props: ['olddetails', 'officeMainActivities','hasmodulesiteweb','usersReinforcement', 'renfortsReinforcement',
            'isencadrantsalarie', 'hasmodulefacturebureau', 'officeencadrant','officecustomization','hasbilling','bookingmultipleenc'],
  data () {
    return {
      mainActivities: [],
      activity: null,
      details: {},
      jsonDetails: '',
      newDetail: {
        name: '',
        quantity: 1,
        price: '',
        date_debut: '',
        date_fin: '',
        isPackagePrice: false,
        nbParticipants: 1
      },
      billingActivityIdIncrement: 0,
      errors: false,
      selectedPrestation: 0,
      prestationTotalPrice: 0,
      dateend: {
        disabledDates: {
          to: new Date(this.beginvalue)
        }
      }
    }
  },
  mounted () {
    if (this.olddetails !== undefined) {
      this.details = this.olddetails
      this.jsonDetails = JSON.stringify(this.details)
      if(this.details.length > 0)
      {
        this.billingActivityIdIncrement = Math.max.apply(Math, this.details.map(function(detail) {
          if(detail.hasOwnProperty('billingActivityId')) {
            return detail.billingActivityId + 1 // if detail has id, next id should be greater
          }
          return 0 // if no id exist, next id can be 0
        }))
        if(this.hasbilling || this.bookingmultipleenc!=null) {
          this.$nextTick(function () {
            this.DisplayEnc(this.details[0],this.details[0].quantity*this.details[0].price)
          });
        }
      }
    }
  },
  created() {
    this.resetActivities();
  },
  computed: {
    priceTotal() {
      let total = 0
      for (let i = this.details.length - 1; i >= 0; i--) {
        total += this.details[i].price * this.details[i].quantity
      }
      this.$parent.$emit('update:totalDispatchedPrice', {
        'type' : 'total',
        'quantity' : total
      })
      return total
    }
  },
  watch: {
    activity(newVal) {
      this.newDetail = { ...this.newDetail, ...newVal };
    },
    jsonDetails() {
      this.$nextTick(function () {
        $("#detail").trigger('change');
      })
    },
    'newDetail.quantity': function (newVal) {
      if (!this.newDetail.isPackagePrice) this.newDetail.nbParticipants = newVal
    },
    'newDetail.isPackagePrice': function (newVal) {
      if (!newVal) this.newDetail.nbParticipants = this.newDetail.quantity
    }
  },
  methods: {
    resetActivities() {
      this.mainActivities = this.deepCopy(this.officeMainActivities)

      this.mainActivities.forEach(act => {
        if (act.price_type === 'package') {
          act.package_prices.forEach(p => {
            p.price = p.price_ttc;
            p.tauxtva = act.tauxtva;
            p.isPackagePrice = true;
          })

          act.isPackagePrice = false;
        }
      })

      this.activity = null;

      for (let key in this.newDetail) {
        this.newDetail[key] = ''
      }
      this.newDetail.quantity = 1;
    },
    addDetail() {
      if (this.newDetail.name !== '' && this.newDetail.quantity && this.newDetail.quantity >= 0
        && this.newDetail.price !== '' && this.newDetail.date_debut !== undefined && this.newDetail.date_debut !== ''
        && this.newDetail.date_fin !== undefined && this.newDetail.date_fin !== '')
      {
        let tempDetail = this.deepCopy(this.newDetail)
        const date_debut = new Date(tempDetail.date_debut)
        tempDetail.date_debut = date_debut.toISOString().slice(0, 10)
        const date_fin = new Date(tempDetail.date_fin)
        tempDetail.date_fin = date_fin.toISOString().slice(0, 10)

        if(tempDetail.billingActivityId === undefined || tempDetail.billingActivityId === "")//when create new prestation
        {
          tempDetail.billingActivityId = this.billingActivityIdIncrement
          this.billingActivityIdIncrement+=1
        }

        if (tempDetail.isPackagePrice)
          tempDetail.name += ' - ' + tempDetail.nbParticipants + ' participant' + (tempDetail.nbParticipants > 1 ? 's' : '');

        this.details.push(tempDetail)
        this.$parent.$emit('update-price', this.priceTotal)

        this.resetActivities();

        this.jsonDetails = JSON.stringify(this.details)
        this.$nextTick(() => {this.DisplayEnc(tempDetail,tempDetail.quantity*tempDetail.price)})
        this.errors = false

        if(!tempDetail.enc || !tempDetail.enc.length > 0)
        {
          $("#detail_form_container :input").prop("disabled", true);
          $("#detail__button").addClass("disabled");
          $("#atLeastOneEnc").show()
        }
      }
      else {
        this.errors = true
      }
    },
    deleteDetail(detail) {
        this.$root.$emit('prestaDelete',detail.billingActivityId)
        this.details.splice(this.details.indexOf(detail), 1)
        this.jsonDetails = JSON.stringify(this.details)
        $("#atLeastOneEnc").hide()
        $("#detail_form_container :input").prop("disabled", false);
        $("#detail__button").removeClass("disabled");
        $("#EncadrantContainer").hide()
    },
    editDetail(detail) {
      this.newDetail = detail
      this.details.splice(this.details.indexOf(detail), 1)

      if (this.newDetail.isPackagePrice) {
        const name = this.newDetail.name;
        this.newDetail.name = name.substring(0, name.lastIndexOf('-') - 1)
      }

      this.$refs.input.focus()
      $("#atLeastOneEnc").hide()
      $("#detail_form_container :input").prop("disabled", false);
      $("#detail__button").removeClass("disabled");
      $("#EncadrantContainer").hide()
    },
    selectedDatebegin(value) {
      this.dateend.disabledDates.to=value;
    },
    DisplayEnc(detail,price)
    {
      let detailId = detail.billingActivityId
      if($("#row_" + detailId).hasClass("activeRow"))
      {
        $("#row_" + detailId).removeClass("activeRow")
        $("#EncadrantContainer").slideUp()
      }
      else
      {
        this.selectedPrestation=detail
        this.prestationTotalPrice=this.price

        let notTarget = $(".prestaEncsContainer").not("#encs_"+detailId).children("tr").children("td,th")
        let target = $("#encs_"+detailId).children("tr").children("td, th")
        let i = 1;
        notTarget.slideUp({duration:"slow",complete:function()
                                  {
                                      if (i === notTarget.size())
                                      {
                                        if(!target.is(":visible"))
                                        {
                                          target.slideDown("slow")
                                        }
                                      }
                                      i += 1;
                                  }})
        $(".tableHead:not(:first)").hide()
        $("#activitiesTable tr").removeClass("activeRow")
        $("#row_"+detailId).addClass("activeRow")
        $("#EncadrantContainer").slideDown()
        //this.scrollTo($("#row_"+detailId))
      }
    },
    /*scrollTo( target ) {
        if( target.length ) {
            $("html, body").stop().animate( { scrollTop: target.offset().top-150 }, 2000);
        }
    },*/
    deepCopy(src) {//to remove reference
      return JSON.parse(JSON.stringify(src))
    },
    encadrantChange(value,renfortValue)
    {
      let checkAtLeastOne = true//at least one encadrant per prestation
      for (const [i, detail] of this.details.entries()) {
        let encs = value.filter(enc => enc.presta == detail.billingActivityId)
        let renfs = renfortValue.filter(renf =>renf.presta == detail.billingActivityId)
        this.details[i]["enc"]=[]
        for (const [j, enc] of encs.entries()) {
          let newEnc = {id:enc.id,name:enc.name,lastname:enc.lastName,part:parseFloat(enc.part),percentage:parseFloat(enc.percentage),quantity:enc.quantity,setWithPart:enc.setWithPart,isRenfort:false}
          this.details[i]["enc"].push(newEnc)
        }
        for (const [j, renf] of renfs.entries()) {
          let newRenf = {id:renf.id,name:renf.name,lastname:renf.lastname,part:parseFloat(renf.part),percentage:parseFloat(renf.percentage),quantity:renf.quantity,setWithPart:renf.setWithPart,isRenfort:true}
          this.details[i]["enc"].push(newRenf)
        }
        if(this.details[i]["enc"].length==0)
        {
          checkAtLeastOne=false
        }
      }
      this.jsonDetails = JSON.stringify(this.details)
      if(checkAtLeastOne)//ok
      {
        $("#atLeastOneEnc").hide()
        $("#detail_form_container :input").prop("disabled", false);
        $("#detail__button").removeClass("disabled");
      }
      else
      {
        $("#atLeastOneEnc").show()
      }
      if($(".activeRow").length==0)
      {
        $("#EncadrantContainer").hide()
      }

    },
    encDelete(proID,prestaID,isRenfort)
    {
      this.$root.$emit('encDelete',proID,prestaID,isRenfort)
    },
    encUpdate(proID,presta,isRenfort)
    {
      $("#activitiesTable tr").removeClass("activeRow")
      $("#row_"+presta.billingActivityId).addClass("activeRow")
      $("#EncadrantContainer").show()
      this.selectedPrestation=presta
      this.$root.$emit('encUpdate',proID,isRenfort)
    },
    getTotalEncQuantity(detail)
    {
      if(detail.hasOwnProperty("enc"))
      {
        return detail["enc"].reduce(function(prev, cur) {
          return prev + +cur.quantity;//double + to cast str to int
        }, 0);
      }
      return 0
    }
  },
  components: {
    Datepicker
  }
}
</script>

<style lang="css" scoped>
  #detail__button{
    margin: 2.5rem;
  }
  .activeRow{
    background-color: #1976d2 !important;
    color: #ffffff
  }
  .activityRow{
    cursor: pointer;
  }
  .activityRow:hover:not(.activeRow){
    background-color: #9bd5ff !important;
  }
</style>
